import React, { useEffect, useState } from "react";
import "./seek.css";
import axios from "axios";
import classNames from "classnames";

export default function Seek() {
  const [hotnews, setHotnews] = useState([]);
  useEffect(() => {
    axios.get("http://mv.venlou.com/news/hot").then((response) => {
      setHotnews(response.data);
    });
  }, []);

  const [num, setNum] = useState(10);
  return (
    <div className="seek">
      {/* 标题 */}
      <div className="seek-title">
        <span>搜索热点</span>
        <img src={require("./img/huan.png")} alt="" className="seek-img" />
        <span
          className="seek-title-right"
          onClick={() => {
            setNum(num + 10);
            if (num === 40) {
              setNum(10);
            }
          }}
        >
          换一换
        </span>
      </div>

      {hotnews !== [] && (
        <>
          {hotnews.slice(num - 10, num).map((item, index) => {
            return (
              <div className="seek-news" key={item.hotnum}>
                <div className="seek-two">
                  <div className="seek-num">
                    <span
                      className={classNames({
                        "color-pink": index + 1 === 1,
                        "color-orange": index + 1 === 2,
                        "color-yellow": index + 1 === 3,
                      })}
                    >
                      {num === 10 && <>{index + 1}</>}
                      {num === 20 && <>{index + 11}</>}
                      {num === 30 && <>{index + 21}</>}
                      {num === 40 && <>{index + 31}</>}
                    </span>
                  </div>
                  <span
                    onClick={() => {
                      window.open(
                        `https://www.baidu.com/s?ie=utf-8&f=8&rsv_bp=1&rsv_idx=1&tn=02003390_42_hao_pg&wd=${item.title}`
                      );
                    }}
                  >
                    {item.title}
                  </span>
                </div>
              </div>
            );
          })}
        </>
      )}
    </div>
  );
}
